import { createMuiTheme } from '@material-ui/core/styles';
import { styledTheme as _styledTheme } from 'heliocor-ui';

const MUITheme = (customColors = {}) => {

    const styledTheme = {
        ..._styledTheme,
        colors: {
            ..._styledTheme.colors,
            main: customColors.mainColor || _styledTheme.colors.main,
            mainText: customColors.mainText || _styledTheme.colors.black,
            stepperBackground: customColors.stepperBackground || _styledTheme.colors.grey700,
            secondaryColor: customColors.secondaryColor || _styledTheme.colors.aqua100
        },
        buttons: {
            ..._styledTheme.buttons,
            backgroundColor: {
                ..._styledTheme.buttons.backgroundColor,
                'default': customColors.mainColor || _styledTheme.colors.main,
                'light-hover': customColors.mainColor ? `${customColors.mainColor}4c` : _styledTheme.colors.main400,
            },
            color: {
                ..._styledTheme.buttons.color,
                'light': customColors.mainColor || _styledTheme.colors.main,
                'white': customColors.mainColor || _styledTheme.colors.main,
            }
        }
    }


    return createMuiTheme({
        palette: {
            default: {
                main: styledTheme.colors.main
            },
            primary: {
                main: styledTheme.colors.main
            },
            secondary: {
                main: styledTheme.colors.main
            },
            action: {
                main: styledTheme.colors.black
            }
        },
        typography: {
            fontFamily: 'Lato',
            fontSize: 14,
            body1: {
                fontFamily: 'Lato',
                fontSize: 14,
            }
        },
        overrides: {
            MuiAppBar: {
                root: {
                    color: 'rgb(0, 0, 0) !important',
                    backgroundColor: '#fff !important'
                }
            },
            MuiButton: {
                root: {
                    opacity: 1,
                    borderRadius: 3,
                    height: 32,
                    minHeight: 32,
                    transition: 'opacity 250ms ease-out',
                },
                label: {
                    fontSize: 16,
                    textTransform: 'capitalize',
                    minWidth: 68,
                    height: 12
                },
                contained: {
                    boxShadow: 'none'
                }
            },
            MuiCollapse: {
                wrapperInner: {
                    display: 'flex',
                    flexDirection: 'column'
                }
            },
            MuiFab: {
                root: {
                    boxShadow: 'none'
                }
            },
            MuiFormControlLabel: {
                root: {
                    width: '100%'
                }
            },
            MuiFormGroup: {
                root: {
                    flexWrap: 'unset'
                }
            },
            MuiGrid: {
                "spacing-xs-5": {
                    marginTop: '3%'
                }
            },
            MuiIconButton: {
                root: {
                    padding: 8
                }
            },
            MuiInput: {
                input: {
                    fontSize: 14,
                    paddingBottom: 6,
                    appearance: 'textfield'
                },
                root: {
                    color: styledTheme.colors.mainText,
                    lineHeight: 1.4,
                    marginBottom: 5,
                    minHeight: 32,
                    border: '1px solid #dddddd',
                    borderRadius: 3,
                    padding: '0 10px',
                    width: '100%',
                    "&::placeholder": {
                        color: styledTheme.colors.grey100
                    },
                    '&$disabled': {
                        background: styledTheme.colors.grey700
                    }
                },
                multiline: {
                    padding: '5px 0 10px'
                },
                underline: {
                    '&:before': {
                        borderBottom: '1px solid #ffffff'
                    },
                    '&:hover:not($disabled):not($focused):not($error):before': {
                        borderBottom: '1px solid #ffffff'
                    },
                    '&:hover:not($disabled):before': {
                        borderBottom: '1px solid #ffffff'
                    },
                    '&:after': {
                        borderBottomWidth: 1,
                        borderBottomColor: styledTheme.colors.main
                    },
                    '&$disabled:before': {
                        borderBottom: '1px solid #ffffff'
                    }
                }
            },
            MuiInputLabel: {
                root: {
                    fontSize: 13,
                    fontWeight: 600,
                    color: styledTheme.colors.mainText,
                    marginBottom: 5,
                    marginTop: 15,
                    width: '100%',
                    display: 'initial'
                }
            },
            MuiList: {
                padding: {
                    paddingTop: 0,
                    paddingBottom: 0
                }
            },
            MuiListItem: {
                root: {
                    "&$selected": {
                        backgroundColor: styledTheme.colors.grey700 + '!important'
                    }
                }
            },
            MuiMenuItem: {
                root: {
                    fontSize: 14,
                    "&$selected": {
                        fontWeight: 800,
                        color: styledTheme.colors.main,
                    }
                }
            },
            MuiMobileStepper: {
                root: {
                    maxWidth: 800,
                    width: ' 96vw',
                    flexGrow: 1,
                    height: '3vh',
                    background: 'transparent'
                },
                progress: {
                    width: '100%'
                }
            },
            MuiPaper: {
                root: {
                    display: 'flex',
                    flexDirection: 'column'
                },
                rounded: {
                    borderRadius: 0
                },
                elevation2: {
                    boxShadow: '0px 2px 8px 1px rgba(0,0,0,0.16)',
                }
            },
            MuiRadio: {
                root: {
                    color: '#c2c2c2',
                    padding: '8px !important',
                    "&$checked": {
                        color: styledTheme.colors.main + '!important'
                    },
                    "&$disabled": {
                        color: '#c2c2c2 !important'
                    }
                }
            },
            MuiSelect: {
                root: {
                    border: 'none'
                },
                selectMenu: {
                    paddingLeft: 5
                }
            },
            MuiSnackbarContent: {
                root: {
                    '@media (min-width: 960px)': {
                        minWidth: 308
                    },
                }
            },
            MuiStepConnector: {
                lineVertical: {
                    minHeight: 12
                },
                vertical: {
                    padding: '0',
                    marginLeft: 11
                }
            },
            MuiStepIcon: {
                root: {
                    fontSize: '1.35rem'
                },
                completed: {
                    fill: styledTheme.colors.secondaryColor
                }
            },
            MuiStepLabel: {
                root: {
                    textAlign: 'initial'
                },
                labelContainer: {
                    minHeight: '2rem',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                label: {
                    fontSize: 12
                }
            },
            MuiTabs: {
                root: {
                    display: 'inline-block',
                    width: '100%'
                },
                indicator: {
                    backgroundColor: styledTheme.colors.main + '!important',
                },
                scroller: {
                    display: 'flex'
                }
            },
            MuiTab: {
                root: {
                    padding: 0
                },
                wrapper: {
                    '@media (min-width: 960px)': {
                        padding: '6px 24px'
                    },
                    padding: '6px 12px'
                }
            },
            MuiTablePagination: {
                selectRoot: {
                    marginTop: 3,
                },
                input: {
                    width: 60,
                    border: 'none'
                },
                toolbar: {
                    paddingRight: 2,
                    paddingLeft: 2
                },
                select: {
                    textAlignLast: 'left'
                }
            },
            MuiTableBody: {
                root: {
                    '& > tr:nth-child(odd)': {
                        backgroundColor: styledTheme.colors.bluelight100
                    }
                }
            },
            MuiTableCell: {
                root: {
                    padding: 0,
                    maxWidth: 36,
                    lineHeight: 1.3,
                    borderBottom: 'none',
                    fontSize: 12,
                    paddingLeft: 16
                },
                body: {
                    color: styledTheme.colors.grey100
                },
                footer: {
                    borderBottom: 'none'
                },
                head: {
                    lineHeight: 1.3
                }
            },
            MuiTableRow: {
                root: {
                    height: 38,
                    '& th:first-child': {
                        paddingLeft: 16,
                    }
                }
            },
            MuiToolbar: {
                regular: {
                    width: '100%'
                }
            },
            MuiTypography: {
                subtitle1: {
                    fontSize: 16,
                    color: styledTheme.colors.mainText,
                    fontWeight: 300,
                },
                body2: {
                    fontSize: 14,
                    color: styledTheme.colors.mainText,
                    fontWeight: 300
                },
                caption: {
                    fontSize: 12
                },
                colorTextSecondary: {
                    color: styledTheme.colors.main
                },
                h4: {
                    fontSize: 14,
                    fontWeight: 600,
                    color: '#444'
                },
                h2: {
                    fontSize: 12,
                    fontWeight: 600,
                    color: '#333'
                },
                h6: {
                    fontSize: 20,
                    color: styledTheme.colors.mainText,
                    fontWeight: 800,
                    // textTransform:'capitalize'
                },
            },
            PrivateSwitchBase: {
                root: {
                    padding: 12
                }
            }
        }
    })
}



export default MUITheme
